import { pick } from 'lodash';
import * as React from 'react';
import { useState } from 'react';
import { FieldValues, SubmitHandler, UseFormReturn } from 'react-hook-form';

import countFieldErrors from '../countFieldErrors.ts';

const hasDirtyField = (dirty: unknown): boolean =>
    dirty === true || (typeof dirty === 'object' && dirty !== null && Object.values(dirty).some(hasDirtyField));

const useSectionSaveStatus = <TFieldValues extends FieldValues>(
    form: UseFormReturn<TFieldValues>,
    onSubmit: SubmitHandler<TFieldValues>
) => {
    const [savingSection, setSavingSection] = useState<string | null>(null);

    const submitSection = (section: string) => (event?: React.BaseSyntheticEvent) => {
        setSavingSection(section);
        return form.handleSubmit(onSubmit)(event);
    };

    const getSaveStatusProps = (section: string, fields: string[]) => ({
        isDirty: hasDirtyField(pick(form.formState.dirtyFields, fields)),
        isSubmitting: form.formState.isSubmitting && savingSection === section,
        errorCount: countFieldErrors(pick(form.formState.errors, fields)),
    });

    return { submitSection, getSaveStatusProps };
};

export default useSectionSaveStatus;
